import React, { useCallback, useEffect } from "react";
import FetchHook from "../../../../Api/FetchHooks";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import moment from "moment/moment";
import GuarantorApprovalForm from "./GuarantorApprovalForm";
import TableComponent from "../../../../Components/TableComponent";
import PageLoader from "../../../../Components/PageLoader";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import ActionDialog from "../../../../Components/ActionDialog";
import Page from "../../../../Components/Page";
import UseServerTable from "../../../../Hooks/UseServerTable";
import ErrorDisplay from "../../../../Components/ErrorDisplay";
import { AllInbox } from "@mui/icons-material";
import { formatCurrencyV2 } from "../../../../utils/helpers";

const GuarantorNominations = ({ _user }) => {
  const location = useLocation();
  const loggedInUser = useSelector((state) => state?.auth?.user);

  const [loading, response, request] = FetchHook();

  const [user, setUser] = useState(
    _user || location?.state?.user || loggedInUser,
  );
  const [data, setData] = useState([]);
  const [nomination, setNomination] = useState();

  const [dialog, setDialog] = useState({
    open: false,
    type: null,
    label: null,
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const openDialog = (type, label) => setDialog({ open: true, type, label });
  const closeDialog = () => setDialog({ open: false, type: null, label: null });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  // const fetchNominations = useCallback(() => {
  //   request({ url: `guarantors?type=other_members&entity_id=${user.id}` });
  // }, [user]);

  // useEffect(() => {
  //   fetchNominations();
  // }, [fetchNominations]);

  // useEffect(() => {
  //   if (response && response.status === 200 && response.data.StatusCode === 0) {
  //     setData(response.data.Data);
  //   }
  // }, [response]);

  const { gridProps, error, refresh } = UseServerTable({
    baseUrl: `guarantors?type=other_members&entity_id=${user.id}`,
    onSuccess: (data) => {
      setData(data.Data);
    },
  });

  useEffect(() => {
    if (error) {
      setSnackbar({
        open: true,
        message: error.message,
        severity: error.severity,
      });
    }
  }, [error]);

  const columns = [
    { field: "id", headerName: "#", width: 150 },
    { field: "loan_id", headerName: "Loan Id", width: 160 },
    { field: "loan_name", headerName: "Loan Name", width: 150 },
    // { field: "loan_amount", headerName: "Loan amount",flex: 1, minWidth: 200 },
    // { field: "saving_amount", headerName: "Savings amount",flex: 1, minWidth: 200 },
    {
      field: "guarantorship_amount",
      headerName: "Requested amount",
      valueFormatter: (param) => formatCurrencyV2(param?.value),
    },
    {
      field: "guaranteered_amount",
      headerName: "Guaranteed amount",
      valueFormatter: (param) => formatCurrencyV2(param?.value),
    },
    // {
    //   field: "guarantorship_amount_bal",
    //   headerName: "Guarantorship amount balance",

    // },
    {
      field: "status",
      headerName: "Status",
      renderCell: (params) => {
        if (params.row.status === 0) {
          return (
            <Chip label="pending" color="warning" sx={{ color: "white" }} />
          );
        } else if (params.row.status === 1) {
          return (
            <Chip label="accepted" color="success" sx={{ color: "white" }} />
          );
        } else if (params.row.status === 3) {
          return (
            <Chip label="rejected" color="error" sx={{ color: "white" }} />
          );
        } else if (params.row.status === 4) {
          return <Chip label="paid off" color="info" sx={{ color: "white" }} />;
        } else if (params.row.status === 5) {
          return (
            <Chip label="recovered" color="info" sx={{ color: "white" }} />
          );
        }
      },
    },
    {
      field: "date_created",
      headerName: "Date created",
      width: 200,
      valueFormatter: (params) =>
        moment(params?.value).format("DD/MM/YYYY, hh:mm:ss a"),
    },
    {
      field: "last_updated_on",
      headerName: "last updated",
      valueFormatter: (params) =>
        moment(params?.value).format("DD/MM/YYYY, hh:mm:ss a"),
      width: 200,
    },
    {
      field: "actions",
      headerName: "Actions",
      renderCell: (params) => {
        return (
          params.row.status === 0 && (
            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                setNomination(params.row);
                openDialog("approve_guarantor", "Guarantor Action");
              }}
            >
              Approve
            </Button>
          )
        );
      },
    },
  ];

  return (
    <>
      <ActionDialog
        open={dialog.open}
        onClose={closeDialog}
        dialogType={dialog.type}
        dialogLabel={dialog.label}
        user={user}
        data={nomination}
        onSuccess={refresh}
      />

      <Card>
        <CardHeader
          title={
            <Typography variant="h6">Guarantorship Nominations</Typography>
          }
          subheader={
            <Typography variant="subtitle1">
              You have {data.length} guarantor nominations.
            </Typography>
          }
        />

        <CardContent>
          {gridProps.loading ? (
            <PageLoader />
          ) : data.length > 0 ? (
            <TableComponent data={data} columns={columns} {...gridProps} />
          ) : (
            <ErrorDisplay
              message="You have no guarantor nominations!"
              icon={
                <AllInbox color="secondary" sx={{ mx: "auto", fontSize: 80 }} />
              }
            />
          )}
        </CardContent>
      </Card>
    </>
  );
};

export default GuarantorNominations;
